<form *ngIf="rateFormGroup" [formGroup]="rateFormGroup">
  <p-card class="p-3" header="Datos generales">
    <div class="grid">
      <div class="col-4 input-field">
        <label for="name">Nombre *</label>
        <input pInputText name="name" formControlName="name" d-form-field-error />
      </div>
      <div class="col-2 input-field ">
        <label for="fromDate">Desde</label>
        <p-calendar [firstDayOfWeek]="1" inputId="fromDate" appendTo="body" dateFormat="dd/mm/yy" formControlName="fromDate"
          d-form-field-error />
      </div>
      <div class="col-2 input-field ">
        <label for="toDate">Hasta</label>
        <p-calendar [firstDayOfWeek]="1" inputId="toDate" appendTo="body" dateFormat="dd/mm/yy" formControlName="toDate"
          d-form-field-error />
      </div>
      <div class="col-2 input-field" *ngIf="type=='COMPANY'">
        <label for="isGeneral">¿Es un baremo general?</label>
        <p-checkbox formControlName="isGeneral" [binary]="true"></p-checkbox>
      </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
      <p-button label="Eliminar" *ngIf="allowDelete && rate.id" icon="pi pi-trash" styleClass="p-button-danger"
        (click)="delete()"></p-button>
      <div class="flex-grow-1"></div>
      <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
      <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
  </p-card>

  <p-tabView *ngIf="rate.id">
    <p-tabPanel header="Líneas de baremo">
      <div class="flex justify-content-end mb-2">
        <p-button label="Cargar Excel" (click)="loadExcel()" icon="pi pi-upload" styleClass="p-button-sm mr-1"
          *ngIf="allowWrite"></p-button>
        <p-button label="Descargar Excel" (click)="downloadExcel()" icon="pi pi-download" styleClass="p-button-sm mr-1"
          *ngIf="allowWrite"></p-button>
        <p-button *ngIf="allowWrite" label="Añadir línea" icon="pi pi-plus" (click)="editRateLine(null)" />
      </div>

      <p-messages severity="info" [closable]="false" *ngIf="rateLines.length > 0">
          <ng-template pTemplate>
              {{rateLines.length}} líneas de baremo encontradas.
          </ng-template>
      </p-messages>

      <p-card *ngFor="let capability of rateLinesCapabilities" [header]="capability.name">
        <p-table #grid [value]="rateLinesByCapability(capability.id)" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th pSortableColumn="rateLineId">Código <p-sortIcon field="rateLineId"></p-sortIcon>
              </th>
              <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon>
              </th>
              <th pSortableColumn="unitPrice">Precio <p-sortIcon field="unitPrice"></p-sortIcon>
              <th pSortableColumn="freePrice">Precio libre <p-sortIcon field="freePrice"></p-sortIcon>
              <th pSortableColumn="uniqueService">Servicio único <p-sortIcon field="uniqueService"></p-sortIcon>
              <th pSortableColumn="fixedAmount">Cantidad fijada <p-sortIcon field="fixedAmount"></p-sortIcon>
              </th>
              <th width=" 100"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rateLine let-columns="columns">
            <tr (dblclick)="editRateLine(rateLine)">
              <td>{{rateLine.code}}</td>
              <td>{{rateLine.description}}</td>
              <td>{{rateLine.price | currency:'EUR'}}</td>
              <td>
                <i class="pi"
                  [ngClass]="{ 'text-green-500 pi-check-circle': rateLine.freePrice, 'text-red-500 pi-times-circle': !rateLine.freePrice }"></i>
              </td>
              <td>
                <i class="pi"
                  [ngClass]="{ 'text-green-500 pi-check-circle': rateLine.uniqueService, 'text-red-500 pi-times-circle': !rateLine.uniqueService }"></i>
              </td>
              <td>{{rateLine.fixedAmount}}</td>
              <td>
                <div class="flex gap-2 justify-content-end">
                  <p-button *ngIf="allowDelete" (click)="deleteRateLine(rateLine.id)" [rounded]="true" [text]="false"
                    severity="danger"><i class="pi pi-trash"></i></p-button>
                  <p-button *ngIf="allowWrite" (click)="editRateLine(rateLine)" [rounded]="true" [text]="false"><i
                      class="pi pi-pencil"></i></p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
      <span *ngIf="rateLinesCapabilities.length == 0">
        No se han encontrado líneas de baremo
      </span>

    </p-tabPanel>

    <p-tabPanel header="Compañías" *ngIf="type=='COMPANY' && rateFormGroup.get('isGeneral')?.value == false">
      <div class="flex justify-content-end pb-1">
        <p-button label="Añadir compañía" (click)="addCompany({})" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table styleClass="mt-4" [value]="companies" [paginator]="true" [rows]="25"
        [totalRecords]="totalCompaniesRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="company">Compañía <p-sortIcon field="company"></p-sortIcon></th>
            <th pSortableColumn="contract">Contrato <p-sortIcon field="contract"></p-sortIcon></th>
            <th pSortableColumn="insuranceCompany">Compañía aseguradora <p-sortIcon field="insuranceCompany"></p-sortIcon></th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rateCompany let-columns="columns">
          <tr>
            <td>{{rateCompany.company?.name}}</td>
            <td>{{rateCompany.contractId != null?rateCompany.contract?.name: "Todos"}}</td>
            <td>{{rateCompany.insuranceCompanyId != null?rateCompany.insuranceCompany?.name: "Todos"}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteCompany(rateCompany)" [rounded]="true"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>                
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado compañías
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Operarios" *ngIf="type=='WORKER'">
      <div class="flex justify-content-end pb-1">
        <p-button label="Añadir operario" (click)="addWorker({})" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table styleClass="mt-4" [value]="workers" [paginator]="true" [rows]="25"
        [totalRecords]="totalWorkersRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="company">Operario <p-sortIcon field="company"></p-sortIcon></th>
            <th pSortableColumn="normalServiceAllowed">Horario normal <p-sortIcon
                    field="normalServiceAllowed"></p-sortIcon></th>
            <th pSortableColumn="guardServiceAllowed">Horario de guardia <p-sortIcon
                    field="guardServiceAllowed"></p-sortIcon></th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rateWorker let-columns="columns">
          <tr (dblclick)="addWorker(rateWorker)">
            <td>{{rateWorker.worker?.name}}</td>
            <td>
                <i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': rateWorker.normalServiceAllowed, 'text-red-500 pi-times-circle': !rateWorker.normalServiceAllowed }"></i>
            </td>
            <td>
                <i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': rateWorker.guardServiceAllowed, 'text-red-500 pi-times-circle': !rateWorker.guardServiceAllowed }"></i>
            </td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteWorker(rateWorker)" [rounded]="true"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                <p-button *ngIf="allowWrite" (click)="addWorker(rateWorker)" [rounded]="true" [text]="false"><i
                    class="pi pi-pencil"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado operarios
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Proveedores" *ngIf="type=='PROVIDER'">
      <div class="flex justify-content-end pb-1">
        <p-button label="Añadir proveedor" (click)="addProvider({})" styleClass="p-button-sm"
          *ngIf="allowWrite"></p-button>
      </div>
      <p-table styleClass="mt-4" [value]="providers" [paginator]="true" [rows]="25"
        [totalRecords]="totalProvidersRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="company">Proveedor <p-sortIcon field="company"></p-sortIcon></th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rateProvider let-columns="columns">
          <tr>
            <td>{{rateProvider.provider != null ? rateProvider.provider?.name : "Todos"}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDelete" (click)="deleteProvider(rateProvider)" [rounded]="true"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado proveedores
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Plantillas">
      <div class="flex justify-content-end pb-1">
        <p-button label="Añadir plantilla" (click)="editRateTemplate(null)" styleClass="p-button-sm"
          *ngIf="allowWriteTemplate"></p-button>
      </div>
      <p-table styleClass="mt-4" [value]="rateTemplates" [paginator]="true" [rows]="25"
        [totalRecords]="totalRateTemplatesRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rateTemplate let-columns="columns">
          <tr (dblclick)="editRateTemplate(rateTemplate)">
            <td>{{rateTemplate.name}}</td>
            <td>
              <div class="flex gap-2 justify-content-end">
                <p-button *ngIf="allowDeleteTemplate" (click)="deleteRateTemplate(rateTemplate)" [rounded]="true"
                  styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                <p-button *ngIf="allowWriteTemplate" (click)="editRateTemplate(rateTemplate)" [rounded]="true" [text]="false"><i
                    class="pi pi-pencil"></i></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              No se han encontrado plantillas de baremo
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>